import React, { useCallback, useState } from "react";
import submit from "submit-form";
import PropTypes from "prop-types";
import Modal from "../../../../../parts/modal-new";

export const SaveMealPlanAsTemplateModal = ({ locals }) => {
  const { query } = locals;
  const { mealPlan: mealPlanId } = query;

  const initialState = {
    title: "",
    description: "",
  };
  const [state, setState] = useState(initialState);

  const { title, description } = state;

  /**
   * Update the state
   * @param {*} newState
   * @returns
   */
  const updateState = (newState) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  /**
   * Create a template with the same meal plan information
   */
  const handleSubmit = () => {
    const body = {
      mealPlanId,
      title: String(title),
      description: String(description),
    };
    submit(`/actions/meal-planner/create-template`, {
      method: "POST",
      body,
    });
  };

  /**
   * Get the input values
   * @param {*} e
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateState({ [name]: value });
  };

  return (
    <Modal className="save-meal-plan-as-template" title="Save as Template">
      <div className="body">
        <div className="inputs">
          <div>
            <label className="label" htmlFor="title">
              Template Title
            </label>
            <input
              type="text"
              placeholder={`Enter template title`}
              name="title"
              value={title}
              onChange={handleInputChange}
              maxLength={60}
            />
          </div>
          <div>
            <label className="label" htmlFor="description">
              Template Description
            </label>
            <textarea
              name="description"
              className="textarea-input"
              placeholder="Enter description here"
              value={description}
              onChange={handleInputChange}
              maxLength={100}
            ></textarea>
          </div>
        </div>

        <div className="buttons justify-end">
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={title.length === 0 || description.length === 0}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

SaveMealPlanAsTemplateModal.propTypes = {
  locals: PropTypes.object,
};
